import React from 'react';
import { EmptyState, Text } from '@wix/design-system';
import { observer } from 'mobx-react-lite';

interface EmptyStateViewContentProps {
  title?: string;
  subtitle?: string;
}

function _EmptyStateViewContent({
  title,
  subtitle,
}: EmptyStateViewContentProps) {
  return (
    <EmptyState
      dataHook="empty-state"
      title={title}
      subtitle={
        <Text dataHook="empty-state-subtitle" size="small" secondary widows>
          {subtitle}
        </Text>
      }
    />
  );
}

export const EmptyStateViewContent = observer(_EmptyStateViewContent);
